import { render, staticRenderFns } from "./Rsljigou.vue?vue&type=template&id=f3bb7adc&scoped=true&"
import script from "./Rsljigou.vue?vue&type=script&lang=js&"
export * from "./Rsljigou.vue?vue&type=script&lang=js&"
import style0 from "./Rsljigou.vue?vue&type=style&index=0&id=f3bb7adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bb7adc",
  null
  
)

export default component.exports